import React from "react";
import { notifyError } from "./notifyError";

export class RouteSafeBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ROUTE ERROR:", error, errorInfo);
    notifyError(error?.message || "Page error");
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <section className="flex items-center justify-center min-h-[50vh] p-5">
          <section className="text-center">
            <h3 className="mb-4 text-2xl font-semibold text-gray-800">
              This section failed to load
            </h3>
            <p className="mb-6 text-lg text-gray-600">
              You can retry without reloading the entire application.
            </p>
            <button
              type="button"
              onClick={this.handleRetry}
              className="px-5 py-3 text-lg text-white rounded-md shadow-lg bg-secondaryColor"
            >
              Retry
            </button>
          </section>
        </section>
      );
    }

    return this.props.children;
  }
}
